export default __webpack_public_path__ + "static/media/1.f21d7cf9.jpg";